import React from 'react';
import { noop } from 'lodash-es';
import { Modal } from '@mantine/core';

import { useIsMobileMedia } from '~/hooks';

import { TitleXSmall } from '../../typography';
import { useAuthContext } from '../../contexts/AuthContext';

import LoginView from './views/LoginView';
import SignupView from './views/SignupView';
import VerifyEmailView from './views/VerifyEmailView';
import ForgotPasswordView from './views/ForgotPasswordView';

const AuthModal = ({ onClose = noop }) => {
  const { authCtx } = useAuthContext();
  const isMobileMedia = useIsMobileMedia();

  let title;
  let view;

  if (authCtx.view === 'login') {
    view = <LoginView />;
    title = <TitleXSmall>Log In to continue</TitleXSmall>;
  } else if (authCtx.view === 'signup') {
    view = <SignupView />;
    title = <TitleXSmall>Create an account to continue</TitleXSmall>;
  } else if (authCtx.view === 'verify-email') {
    view = <VerifyEmailView />;
    title = <TitleXSmall>Verify your e-mail</TitleXSmall>;
  } else if (authCtx.view === 'forgot-password') {
    view = <ForgotPasswordView />;
    title = <TitleXSmall>Reset your password</TitleXSmall>;
  }

  const modalStyles = {
    inner: {
      padding: isMobileMedia ? '0' : '',
      top: isMobileMedia ? 'unset' : '0',
    },
    modal: {
      padding: isMobileMedia ? '24px' : '32px',
      width: isMobileMedia ? '100%' : '500px',
      borderRadius: isMobileMedia ? '8px 8px 0 0' : '8px',
    },
  };

  return (
    <Modal
      opened={authCtx.open}
      styles={modalStyles}
      title={title}
      onClose={onClose}
      centered
      closeOnEscape={false}
      closeOnClickOutside={false}
    >
      {view}
    </Modal>
  );
};

export default AuthModal;
